<template>
  <div class="content-wrapper">
    <div class="content">
      <div class="card margin-top-5">
        <div class="card-header">
          <h4>{{ pageConfig.title }}</h4>
        </div>
        <div class="card-body card-white">
          <quill-editor 
            ref="myTextEditor" 
            v-model="content" 
            :config="editorOption"
          />
        </div>
        <div class="card-footer">
          <button 
            @click="save" 
            class="pull-right btn btn-default"
            :disabled="loading"
          >
            {{ $t("action.save") }}
          </button>
          <router-link 
            :to="{ name: 'pageContent', params: { type: pageType } }" 
            class="pull-right btn btn-default"
          >
            {{ $t("action.preview") }}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import AlertService from "@/services/alertService";

const PAGE_CONFIGS = {
  cookies_policy: {
    title: "Editer le style de votre page (Cookies de confidentialité)",
    name: "Cookies de confidentialité"
  },
  privacy_policy: {
    title: "Editer le style de votre page (Politique de confidentialité)",
    name: "Politique de confidentialité"
  },
  terms_of_use: {
    title: "Editer le style de votre page (Condition d'utilisation)",
    name: "Condition d'utilisation"
  }
};

export default {
  name: "PageEditor",
  
  components: {
    quillEditor
  },

  props: {
    pageType: {
      type: String,
      required: true,
      validator: (value) => Object.keys(PAGE_CONFIGS).includes(value)
    }
  },

  data() {
    return {
      content: "",
      editorOption: {},
      id: null,
      loading: false
    };
  },

  computed: {
    pageConfig() {
      return PAGE_CONFIGS[this.pageType];
    }
  },

  beforeMount() {
    this.fetchPageContent();
  },

  methods: {
    async fetchPageContent() {
      try {
        const response = await this.$axios({
          url: `page/${this.pageType}`,
          method: "GET"
        });

        if (response.data.length > 0) {
          this.content = response.data[0].content;
          this.id = response.data[0].id;
        }
      } catch (err) {
        console.error("Error fetching page content:", err.response?.data || err);
        AlertService.show({
          title: "Erreur lors du chargement",
          icon: "error"
        });
      }
    },

    async save() {
      if (this.loading) return;

      this.loading = true;
      const url = this.id === null 
        ? "admin/page/create" 
        : `admin/page/update/${this.id}`;

      try {
        await this.$axios({
          url,
          method: "POST",
          data: {
            content: this.content,
            type: this.pageType,
            name: this.pageConfig.name
          }
        });

        AlertService.show({
          title: "Les changements ont été enregistrés avec succès !",
          icon: "success"
        });
      } catch (err) {
        console.error("Error saving page:", err.response?.data || err);
        AlertService.show({
          title: "Erreur lors de l'enregistrement",
          icon: "error"
        });
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>